import React, {Component} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownBoxCoordinator} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Types.
 */

export interface InviteTeammatePopoverDropdownItem<Key, Value> {
  name: React.ReactNode;
  key: Key;
  value: Value;
}

/*
 * Props.
 */

interface InviteTeammatePopoverDropdownProps<Key, Value> {
  onSelect: HandlerOf<InviteTeammatePopoverDropdownItem<Key, Value>>;
  items: ReadonlyArray<InviteTeammatePopoverDropdownItem<Key, Value>>;
  selectedItemKey: Key;
}

/*
 * Style.
 */

const StyledDropdownBoxCoordinator = styled(DropdownBoxCoordinator)`
  padding: 0;
`;

/*
 * Component.
 */

export class InviteTeammatePopoverDropdown<Key, Value> extends Component<
  InviteTeammatePopoverDropdownProps<Key, Value>
> {
  constructor(props: InviteTeammatePopoverDropdownProps<Key, Value>) {
    super(props);
  }

  render() {
    const {items, selectedItemKey} = this.props;
    const itemForSelectedKey = items.find((i) => i.key === selectedItemKey);
    const value = itemForSelectedKey ? itemForSelectedKey.name : '';

    const renderDropdown = (modalProps: PopoverTransferProps) => (
      <SimpleDropdown {...modalProps}>
        {items.map((i) => (
          <SimpleDropdownItem onSelect={() => this.props.onSelect(i)}>{i.name}</SimpleDropdownItem>
        ))}
      </SimpleDropdown>
    );

    return (
      <StyledDropdownBoxCoordinator
        value={value}
        size={VisualSizesEnum.MEDIUM}
        renderDropdown={(modalProps) => renderDropdown(modalProps)}
      />
    );
  }
}
